"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
var getMailboxCalendarConfiguration_1 = require("../services/getMailboxCalendarConfiguration");
exports.default = legacy_1.action('initCalendarMailboxConfiguration')(function initCalendarMailboxConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (store_1.default.calendarConfiguration) {
                        // If we already have the mailbox configuration, we won't get it again
                        return [2 /*return*/];
                    }
                    _a = store_1.default;
                    return [4 /*yield*/, getMailboxCalendarConfiguration_1.default()];
                case 1:
                    _a.calendarConfiguration = _b.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=initCalendarMailboxConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/owa-calendar-configuration/lib/actions/initCalendarMailboxConfiguration.js
// module id = 3765
// module chunks = 2